
import './Transaction.css';
import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import axios from "axios";
import { conn } from "../../Utilt/conn";
import { Sidenav } from "../SideNav/Sidenav";
import { CustomNavbar } from "../CustomNavbar/customnabar";
import Loader from "../Loader/Loader";
import { BsSearch } from 'react-icons/bs'
import transact from '../../Assets/ICONS/transact.png'

const { FormatMoney } = require('format-money-js');

const fm = new FormatMoney({
    decimals: 2
});

export const Transactions = () => {

    const [isloading, loading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const[isempty, setIsEmpty] = useState(false);


    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")

    const config = {
        headers: {
            "Content-Type": "application/json",
            'token': token,
            'refreshtoken': refreshtoken
        }
    };

    useEffect(() => {
         (token === null && location.state === null) && navigate("/welcome") 
         FetchTransactions(location.state.nuban);
    }, []);


    const FetchTransactions = async (id) => {

        await axios.post(conn + "/account/transactions", {
            "input": id.toString(),
            "page": "2",
            "limit": "10"
        }, config).then((value) => {
            console.log({
                "input": id.toString(),
                "page": "1",
                "limit": "10"
            });
            console.log(value.data);
            setData(value.data.data);
            if(value.data.data.length === 0){
                setIsEmpty(true);
            }else{
                setIsEmpty(false);
            }
            loading(false);
        }).catch((error) => {
            console.log(error);
            loading(false);
            if (error.response.status === 401) navigate('/login')

        })

    }

    return (

        <div className="transactions">

            <Sidenav />


            <section className="body the-body">

                <CustomNavbar label={"Customers Transactions"} />


                <div className="in">

                    <div className="account_no">

                        <p>{location.state.nuban}</p>
                        <p>Nuban</p>

                    </div>

                    <Fade>
                    <div className="search">

                        <input type="text" placeholder="Search for transaction with reference number" />

                        <span style={{ cursor: "pointer" }} onClick=""><BsSearch /></span>

                    </div>
                    </Fade>

                    {!isempty ? <div className="transaction_list">

                        <p style={{ color: "green", margin: "2vh 2vh" }}>Transactions</p>


                        { data.length > 0 ?

                        <div className="table">

                            <table>
                                <thead>
                                    <td>Narration</td>
                                    <td>Amount</td>
                                    <td>Date</td>
                                    <td>Transaction ref</td>
                                    <td>Status</td>
                                </thead>

                                {

                                    data.map((dt, key) =>

                                        <tr key={key}>
                                            <td><Fade duration={1000}>{dt.from_name + "  TO  " + dt.to_name}</Fade></td>
                                            <td style={(dt.from_account_no === location.state.nuban) ? { color: "red" } : { color: "green" }}><Fade duration={1000}><span className="numba">{fm.from(parseFloat(dt.amt / 100), { symbol: '' })}</span></Fade></td>
                                            <td className="numba"><Fade>{dt.created_on.substring(0, 10)}</Fade></td>
                                            <td><Fade duration={1000}>{dt.transaction_ref}</Fade></td>
                                            <td><Fade duration={1000}><span style={{color:"green"}}>Approved</span></Fade></td>
                                        </tr>

                                    )

                                }

                    

                            </table>

                        </div>:<>{isloading && <Loader />}</> }

                    </div>:<center className="empty">
                    <img src={transact} />
                    <br></br>
                            <p style={{ textAlign: "center", margin: "1vh 0vh", fontSize: "14px" }}>No Transactions Yet</p>
                        </center>}

                </div>


            </section>

    

        </div>

    );

}